import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {InternalEmailDataModel} from '../../models/communication/internal-email-data.model';
import {InternalMessagingFilterModel} from '../../dialog/notifications/internal-messaging-dialog/models/internal-messaging-filter.model';

@Injectable({
  providedIn: 'root'
})
export class InternalEmailService {

  constructor(private http: HttpClient) {

  }

  getInternalEmails(locid: number, model: InternalMessagingFilterModel) {
    return this.http.post<InternalEmailDataModel[]>(`api/internal-email/get-internal-emails/${locid}`, model);
  }

  getUnreadEmails(userId: string) {
    return this.http.get<InternalEmailDataModel[]>(`api/internal-email/get-unread-emails/${userId}`);
  }

  saveInternalEmail(model: InternalEmailDataModel) {
    return this.http.post<void>('api/internal-email/save-internal-email', model);
  }

  deleteInternalEmails(ids: string[]) {
    return this.http.get<void>(`api/internal-email/delete-internal-emails/${ids}`);
  }

  moveToFolder(ids: string[], folderEnum: string) {
    return this.http.post<void>(`api/internal-email/move-to-folder/${folderEnum}`, ids);
  }

  markAsRead(IEmailToID: string) {
    return this.http.get<void>(`api/internal-main/mark-as-read/${IEmailToID}`);
  }
}
